import React from 'react'
import PagesSectionContainer from '../../containers/PageWebsiteSubpages/PagesSectionContainer';


const DisplayPagesSection = ({transId, type}) => {
    return (
        <PagesSectionContainer
            type={type}   
            transId={transId}
        />
    )
}

export default DisplayPagesSection